import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

interface FundingEventsTableProps {
  events: any[];
}

function num(v: any): number {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

function tsMs(e: any): number {
  const t = Number(e?.time ?? e?.ts ?? e?.timestamp ?? 0);
  return Number.isFinite(t) ? t : 0;
}

export function FundingEventsTable({ events }: FundingEventsTableProps) {
  return (
    <div className="rounded-lg border overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Time</TableHead>
            <TableHead>Coin</TableHead>
            <TableHead className="text-right">Funding</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {events.slice(0, 200).map((e, idx) => {
            const t = tsMs(e);
            const coin = e?.coin ?? e?.asset ?? e?.symbol ?? e?.delta?.coin ?? "-";
            const funding = num(e?.funding ?? e?.usdc ?? e?.amount ?? e?.delta?.usdc ?? e?.delta ?? 0);

            return (
              <TableRow key={idx}>
                <TableCell className="font-mono text-xs text-muted-foreground">
                  {t ? new Date(t).toLocaleString() : "-"}
                </TableCell>
                <TableCell className="font-medium">{coin}</TableCell>
                <TableCell className="text-right font-mono">{funding >= 0 ? "+" : ""}${funding.toFixed(2)}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}
